import { get } from 'lodash';
import { connect } from 'react-redux';

import TopNavigationMobile from 'components/TopNavigationMobile';
import { CAMPAIGN_NAMES, RERUN_LABEL } from 'constants/personalizations';
import { SEARCH_ORIGINATIONS } from 'constants/search';
import { TYPES } from 'constants/topNavigation';
import * as actions from 'state/actions';
import CartSelector from 'state/selectors/cart';
import PersonalizationsSelector from 'state/selectors/personalizations';
import TopNavigationSelector from 'state/selectors/top-navigation';
import Rudderstack from 'utils/Rudderstack';
import Settings from 'utils/Settings';

const mapStateToProps = state => {
  const l0ActiveNode = TopNavigationSelector.getActiveNodeAtDepth(state, 0);
  const l1ActiveNode = TopNavigationSelector.getActiveNodeAtDepth(state, 1);
  const l2ActiveNode = TopNavigationSelector.getActiveNodeAtDepth(state, 2);

  const showSearch = Settings.searchIconEnabled;

  const { itemCount } = CartSelector.getCart(state);
  const isCartOpen = CartSelector.getIsCartOpen(state);
  const isQuickSearchOpen = get(state, ['topNavigation', 'isSearchQuickResultsOpen']);

  // Rerun Renaming Experiment
  const navigationRerunRenamingExperimentVariation =
    PersonalizationsSelector.getCampaignVariationData(
      state,
      CAMPAIGN_NAMES.NAVIGATION_RERUN_RENAMING
    );
  const navigationRerunRenamingExperimentAnalyticsData = {
    dyDecisionId: navigationRerunRenamingExperimentVariation?.decisionId,
    dyVariationId: navigationRerunRenamingExperimentVariation?.analyticsMetadata?.variationId,
  };

  if (
    navigationRerunRenamingExperimentVariation?.payload?.data?.label &&
    l0ActiveNode?.subNavigations?.length
  ) {
    l0ActiveNode.subNavigations.forEach(subNavigation => {
      if (subNavigation.label.toLowerCase() === RERUN_LABEL) {
        subNavigation.label = navigationRerunRenamingExperimentVariation?.payload?.data?.label;
      }
    });
  }

  return {
    cartItemCount: itemCount,
    isCartOpen,
    l0ActiveNode,
    l1ActiveNode,
    l2ActiveNode,
    isQuickSearchOpen,
    showSearch,
    navigationRerunRenamingExperimentAnalyticsData,
  };
};

const mapDispatchToProps = dispatch => ({
  openQuickSearch: origination => {
    document.body.style.overflow = 'hidden';
    dispatch(actions.openSearchQuickResults());
    Rudderstack.productsSearchInitiated({
      searchSource: window.location.href,
      searchEntry:
        origination === SEARCH_ORIGINATIONS.QUICK_SEARCH_BAR
          ? SEARCH_ORIGINATIONS.QUICK_SEARCH_BAR
          : SEARCH_ORIGINATIONS.QUICK_SEARCH_ICON,
    });
  },
  closeQuickSearch: () => {
    document.body.style.overflow = 'auto';
    dispatch(actions.closeSearchQuickResults());
  },
  openCart: () => dispatch(actions.openCart({ origination: 'topNavigationCartIcon' })),
  setCurrentTopNavigationNode: id => dispatch(actions.setCurrentTopNavigationNode(id)),
  toggleTopNavigation: () => dispatch(actions.toggleTopNavigation()),
  trackNavigation: url => {
    dispatch(actions.trackTopNavigationNavigation(url));
    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
  trackSearchNavigation: url => {
    dispatch(actions.trackSearchNavigation(url));

    Rudderstack.navigationClicked({
      navigationType: TYPES.SEARCH,
      navigationSource: url,
    });

    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
  trackNavigationRerunRenamingExperimentEngagement: (dyDecisionId, dyVariationId) => {
    dispatch(
      actions.trackEngagementClick({
        dyDecisionId,
        dyVariationId,
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNavigationMobile);
